/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EpaOperatorNotificationStatusEnum } from './EpaOperatorNotificationStatusEnum';
import {
    EpaOperatorNotificationStatusEnumFromJSON,
    EpaOperatorNotificationStatusEnumFromJSONTyped,
    EpaOperatorNotificationStatusEnumToJSON,
    EpaOperatorNotificationStatusEnumToJSONTyped,
} from './EpaOperatorNotificationStatusEnum';
import type { EpaNotificationRequest } from './EpaNotificationRequest';
import {
    EpaNotificationRequestFromJSON,
    EpaNotificationRequestFromJSONTyped,
    EpaNotificationRequestToJSON,
    EpaNotificationRequestToJSONTyped,
} from './EpaNotificationRequest';
import type { SimpleDataPointRequest } from './SimpleDataPointRequest';
import {
    SimpleDataPointRequestFromJSON,
    SimpleDataPointRequestFromJSONTyped,
    SimpleDataPointRequestToJSON,
    SimpleDataPointRequestToJSONTyped,
} from './SimpleDataPointRequest';
import type { SiteRequest } from './SiteRequest';
import {
    SiteRequestFromJSON,
    SiteRequestFromJSONTyped,
    SiteRequestToJSON,
    SiteRequestToJSONTyped,
} from './SiteRequest';

/**
 * Serializer for the EpaOperatorNotification model.
 * @export
 * @interface PatchedEpaOperatorNotificationRequest
 */
export interface PatchedEpaOperatorNotificationRequest {
    /**
     * 
     * @type {EpaNotificationRequest}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    notification?: EpaNotificationRequest;
    /**
     * 
     * @type {SiteRequest}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    nearestSite?: SiteRequest | null;
    /**
     * 
     * @type {Array<SiteRequest>}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    otherNearSites?: Array<SiteRequest> | null;
    /**
     * 
     * @type {SimpleDataPointRequest}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    dataPoint?: SimpleDataPointRequest | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    epaEmissionRecord?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    assignee?: number | null;
    /**
     * 
     * @type {EpaOperatorNotificationStatusEnum}
     * @memberof PatchedEpaOperatorNotificationRequest
     */
    status?: EpaOperatorNotificationStatusEnum;
}



/**
 * Check if a given object implements the PatchedEpaOperatorNotificationRequest interface.
 */
export function instanceOfPatchedEpaOperatorNotificationRequest(value: object): value is PatchedEpaOperatorNotificationRequest {
    return true;
}

export function PatchedEpaOperatorNotificationRequestFromJSON(json: any): PatchedEpaOperatorNotificationRequest {
    return PatchedEpaOperatorNotificationRequestFromJSONTyped(json, false);
}

export function PatchedEpaOperatorNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedEpaOperatorNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'notification': json['notification'] == null ? undefined : EpaNotificationRequestFromJSON(json['notification']),
        'nearestSite': json['nearest_site'] === undefined ? undefined : json['nearest_site'] === null ? null : SiteRequestFromJSON(json['nearest_site']),
        'otherNearSites': json['other_near_sites'] === undefined ? undefined : json['other_near_sites'] === null ? null : ((json['other_near_sites'] as Array<any>).map(SiteRequestFromJSON)),
        'dataPoint': json['data_point'] === undefined ? undefined : json['data_point'] === null ? null : SimpleDataPointRequestFromJSON(json['data_point']),
        'epaEmissionRecord': json['epa_emission_record'] === undefined ? undefined : json['epa_emission_record'] === null ? null : json['epa_emission_record'],
        'assignee': json['assignee'] === undefined ? undefined : json['assignee'] === null ? null : json['assignee'],
        'status': json['status'] == null ? undefined : EpaOperatorNotificationStatusEnumFromJSON(json['status']),
    };
}

export function PatchedEpaOperatorNotificationRequestToJSON(json: any): PatchedEpaOperatorNotificationRequest {
    return PatchedEpaOperatorNotificationRequestToJSONTyped(json, false);
}

export function PatchedEpaOperatorNotificationRequestToJSONTyped(value?: PatchedEpaOperatorNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification': EpaNotificationRequestToJSON(value['notification']),
        'nearest_site': SiteRequestToJSON(value['nearestSite']),
        'other_near_sites': value['otherNearSites'] == null ? undefined : ((value['otherNearSites'] as Array<any>).map(SiteRequestToJSON)),
        'data_point': SimpleDataPointRequestToJSON(value['dataPoint']),
        'epa_emission_record': value['epaEmissionRecord'],
        'assignee': value['assignee'],
        'status': EpaOperatorNotificationStatusEnumToJSON(value['status']),
    };
}

